import React, { useState } from 'react';
import '../Portfolio.css';

const PortfolioItem = ({ project }) => {
  const [rotation, setRotation] = useState({ rotateX: 0, rotateY: 0 });
  const [showModal, setShowModal] = useState(false);

  const handleMouseMove = (e) => {
    const { width, height, left, top } = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - left;
    const y = e.clientY - top;

    // Инверсия углов наклона
    const rotateY = ((x / width) - 0.5) * 10;
    const rotateX = ((y / height) - 0.5) * -10;

    setRotation({ rotateX, rotateY });
  };

  const handleMouseLeave = () => {
    setRotation({ rotateX: 0, rotateY: 0 });
  };

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <div
        className="portfolio-item"
        style={{
          transform: `perspective(1000px) rotateX(${rotation.rotateX}deg) rotateY(${rotation.rotateY}deg)`
        }}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        onClick={handleOpenModal}
      >
        <img src={project.mainImage} alt={project.name} className="portfolio-thumbnail" />
        <div className="portfolio-item-content">
          <h2>{project.name}</h2>
          <p>{project.description}</p>
        </div>
      </div>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <button onClick={handleCloseModal} className="modal-close">
              &times;
            </button>
            <img src={project.mainImage} alt={project.name} className="modal-image" />
            <h2>{project.name}</h2>
            <p>{project.description}</p>
            <a href={project.link} target="_blank" rel="noopener noreferrer" className="modal-link">
              Visit Site
            </a>

            {/* Галерея изображений в модальном окне */}
            <div className="gallery">
              {project.gallery.map((image, index) => (
                <img key={index} src={image} alt={`${project.name} screenshot ${index + 1}`} className="gallery-image" />
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PortfolioItem;
